var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7 37.0667V22.4333C69.7 19.7 67.6334 16.6 65.0667 15.5666L46.5 7.96665C42.3334 6.26665 37.6334 6.26665 33.4667 7.96665L14.9 15.5666C12.3667 16.6 10.3 19.7 10.3 22.4333V37.0667C10.3 53.3666 22.1334 68.6333 38.3 73.1C39.4 73.4 40.6 73.4 41.7 73.1C57.8667 68.6333 69.7 53.3666 69.7 37.0667ZM42.5 42.9V51.6666C42.5 53.0333 41.3667 54.1666 40 54.1666C38.6334 54.1666 37.5 53.0333 37.5 51.6666V42.9C34.1334 41.8333 31.6667 38.7 31.6667 35C31.6667 30.4 35.4 26.6666 40 26.6666C44.6 26.6666 48.3334 30.4 48.3334 35C48.3334 38.7333 45.8667 41.8333 42.5 42.9Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.3ebec056147df992095bb78ae124326f.svg";
export { ForwardRef as ReactComponent };